/**
 * A function that validates the form input and adds proper css to the inputs
 *  @param {FormViewer} ctx The formviewer context for which the validation shall be happen
 *  @returns {boolean} A boolean value that represents the state of the the form valid(true) and invalid (false)
 */

function validateForm(ctx) {
  // --- attributes
  //min length of signature
  // const SIGN_REQUIRED_LENGTH = 35; //Sync this with CustomerService.js

  //validate form controls
  let invalidInputs = ctx.node.querySelectorAll(":invalid");
  for (let i = 0; i < invalidInputs.length; i++) {
    const invalidInput = invalidInputs[i];

    if (invalidInput.name === "epaper" || invalidInput.name === "print") {
      if (!invalidInput.classList.container.classList.contains("hidden")) {
        // The epaper / print container is hidden -> dont validate
        invalidInput.classList.add("not-valid");
      } else {
        invalidInput.classList.remove("not-valid");
        invalidInput.setCustomValidity("");
        continue;
      }
    } else {
      invalidInput.classList.add("not-valid");
    }

    if (invalidInput.tagName === "SELECT") {
      invalidInput.classList.remove("selectreqired");
      invalidInput.classList.add("selectinvalid");
    }
    if (invalidInput.validationMessage === lng.get("form-invalid-empty"))
      invalidInput.setCustomValidity("");
    if (invalidInput.validity.valueMissing) {
      invalidInput.setCustomValidity(lng.get("form-invalid-empty"));
    }
    // special treatment checkbox
    if (
      invalidInput.type === "checkbox" &&
      invalidInput.parentElement.parentElement.parentElement.classList.contains(
        "text-container"
      )
    ) {
      const textContainer =
        invalidInput.parentElement.parentElement.parentElement;
      textContainer.classList.add("not-valid");
    }

    if (invalidInput.calculatedWeekDay) {
      invalidInput.value = invalidInput.calculatedWeekDay;
      invalidInput.setCustomValidity("");
      invalidInput.classList.remove("not-valid");
    }

    // multiChoice handling
    if (invalidInput.type === "checkbox" || invalidInput.type === "radio") {
      // get multichoice container element
      const multiChoiceElem = closest(invalidInput, ".input-multichoice");
      if (multiChoiceElem && invalidInput.required) {
        // remove not-valid from all elements if on is checked, otherwise add not-valid
        const inputs = multiChoiceElem.querySelectorAll(
          'input[type="radio"], input[type="checkbox"]'
        );
        if (Array.from(inputs).some((inputs) => inputs.checked)) {
          inputs.forEach((input) =>
            closest(input, ".multichoice-elem").classList.remove("not-valid")
          );
        } else {
          inputs.forEach((input) =>
            closest(input, ".multichoice-elem").classList.add("not-valid")
          );
        }
      }
    }
  }

  // special treatment vor canvas (has no :invalid attr)
  let invalidCanvas = [];
  let canvas = ctx.node.querySelectorAll("canvas.required");
  if (canvas) {
    for (var i = 0; i < canvas.length; i++) {
      if (canvas[i].path.length <= canvas[i].dataset.SIGN_REQUIRED_LENGTH) {
        canvas[i].classList.add("not-valid");
        invalidCanvas.push(canvas[i]);
      }
    }
  }

  invalidInputs = ctx.node.querySelectorAll(":invalid");

  // validation msg handling
  if (invalidInputs.length > 0 || invalidCanvas.length > 0) {
    if (invalidInputs.length > 0) {
      invalidInputs[0].scrollIntoView({ behavior: "smooth", block: "start" });
      invalidInputs[0].focus();

      let validationMessage = invalidInputs[0].validationMessage;
      if (
        invalidInputs[0].type === "checkbox" &&
        invalidInputs[
          i
        ].parentElement.parentElement.parentElement.classList.contains(
          "text-container"
        )
      )
        validationMessage = lng.get("form-invalid-checkbox");
      //custom validation message
      if (invalidInputs[0].dataset.validationMessage)
        validationMessage = invalidInputs[0].dataset.validationMessage;
      if (validationMessage) snackbar.show({ message: validationMessage });
    } else {
      canvas[0].scrollIntoView({ behavior: "smooth", block: "start" });
      snackbar.show({ message: lng.get("form-invalid-canvas") });
    }
    return false;
  }
  return true;
}
